import axios from 'axios';
import type {
  SubmitConsultationRequest,
  SubmitConsultationAlertRequest,
  ConsultationResponse,
} from '../types/consultation';

/**
 * 提交一般諮詢
 * POST /line/consultation
 */
export const submitConsultation = async (
  data: SubmitConsultationRequest
): Promise<ConsultationResponse> => {
  try {
    const response = await axios.post<ConsultationResponse>(
      process.env.REACT_APP_FORM_URL!,
      data
    );
    return response.data;
  } catch (error) {
    console.error('Error submitting consultation:', error);
    throw error;
  }
};

/**
 * 提交警訊諮詢
 * POST /line/consultation/alert
 */
export const submitConsultationAlert = async (
  data: SubmitConsultationAlertRequest
): Promise<ConsultationResponse> => {
  try {
    const response = await axios.post<ConsultationResponse>(
      process.env.REACT_APP_WARNING_URL!,
      data
    );
    return response.data;
  } catch (error) {
    console.error('Error submitting consultation alert:', error);
    throw error;
  }
};
